import React, { createContext, ReactNode, useContext, useState } from 'react';

interface DocumentContextType {
  documentNumber: string | null;
  setDocumentNumber: (documentNumber: string | null) => void;
  clearDocumentNumber: () => void;
}

const DocumentContext = createContext<DocumentContextType | undefined>(
  undefined
);

interface DocumentProviderProps {
  children: ReactNode;
}

export const DocumentProvider: React.FC<DocumentProviderProps> = ({
  children
}) => {
  const [documentNumber, setDocumentNumberState] = useState<string | null>(
    null
  );

  const setDocumentNumber = (documentNumber: string | null) => {
    setDocumentNumberState(documentNumber);
  };

  const clearDocumentNumber = () => {
    setDocumentNumberState(null);
  };

  return (
    <DocumentContext.Provider
      value={{
        documentNumber,
        setDocumentNumber,
        clearDocumentNumber
      }}
    >
      {children}
    </DocumentContext.Provider>
  );
};

// eslint-disable-next-line react-refresh/only-export-components
export const useDocument = (): DocumentContextType => {
  const context = useContext(DocumentContext);
  if (context === undefined) {
    throw new Error('useDocument must be used within a DocumentProvider');
  }
  return context;
};
